import { render, staticRenderFns } from "./index.html?vue&type=template&id=e88d78e8&scoped=true&"
import script from "./script.js?vue&type=script&lang=js&"
export * from "./script.js?vue&type=script&lang=js&"
import style0 from "./style.less?vue&type=style&index=0&id=e88d78e8&lang=less&scoped=true&"
import style1 from "./mobile.less?vue&type=style&index=1&id=e88d78e8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e88d78e8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e88d78e8')) {
      api.createRecord('e88d78e8', component.options)
    } else {
      api.reload('e88d78e8', component.options)
    }
    module.hot.accept("./index.html?vue&type=template&id=e88d78e8&scoped=true&", function () {
      api.rerender('e88d78e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/event/index/index.vue"
export default component.exports